@if (pageContents) {
  <div class="ontario-row">
    <h1>{{'Tab.FAQs' | translate}}</h1>
    <div class="ontario-column ontario-small-6 ontario-medium-6 ontario-large-6">
      @if (camapageContents.length>0) {
        <h2>{{'FAQHome.Createandmanageaccount' | translate}}</h2>
        @for (hasOpenAccordion of [hasOpenAccordion(camaAccordionList??camapageContents)]; track hasOpenAccordion) {
          <ng-container style="border-bottom: 1px;">
            <button class="ontario-button ontario-button--tertiary expando-button float-right" (click)="expandOrCollapse( hasOpenAccordion, camaAccordionList)">
              {{hasOpenAccordion ? ('General.CollapseAll' | translate) : ('General.ExpandAll' | translate)}}
            </button>
          </ng-container>
        }
        @for (pc of camapageContents; track pc; let i = $index) {
          @if (i==1) {
            <div id="password" [ngClass]="{'border-bottom': i == (camapageContents.length)-1}">
              <app-accordion #cama [accordionTitle]="currentLang == 'en' ? pc.Title: pc.TitleFr" [accordionIndex]="-1" [accordionBody]="currentLang == 'en'? pc.Content: pc.ContentFr">
              </app-accordion>
            </div>
          }
          @if (i!=1) {
            <div disabled class="Testing123" #{{i}} [ngClass]="{'border-bottom': i == (camapageContents.length)-1}">
              <app-accordion #cama [accordionTitle]="currentLang == 'en' ? pc.Title: pc.TitleFr" [accordionIndex]="-1" [accordionBody]="currentLang == 'en'? pc.Content: pc.ContentFr">
              </app-accordion>
            </div>
          }
        }
      }
      @if (ecpageContents.length>0) {
        <h2>{{'FAQHome.EligibilityCheck' | translate}}</h2>
        @for (hasOpenAccordion of [hasOpenAccordion(ecAccordionList??ecpageContents)]; track hasOpenAccordion) {
          <ng-container
            style="border-bottom: 1px;">
            <button class="ontario-button ontario-button--tertiary expando-button float-right" (click)="expandOrCollapse( hasOpenAccordion, ecAccordionList)">
              {{hasOpenAccordion ? ('General.CollapseAll' | translate) : ('General.ExpandAll' | translate)}}
            </button>
          </ng-container>
        }
        @for (pc of ecpageContents; track pc; let i = $index) {
          <div [ngClass]="{'border-bottom': i == (ecpageContents.length)-1}">
            <app-accordion #ec [accordionTitle]="currentLang == 'en' ? pc.Title: pc.TitleFr" [accordionIndex]="-1" [accordionBody]="currentLang == 'en'? pc.Content: pc.ContentFr">
            </app-accordion>
          </div>
        }
      }
      @if (ulpageContents.length>0) {
        <h2>{{'FAQHome.UsefulLinks' | translate}}</h2>
        @for (hasOpenAccordion of [hasOpenAccordion(ulAccordionList??ulpageContents)]; track hasOpenAccordion) {
          <ng-container
            style="border-bottom: 1px;">
            <button class="ontario-button ontario-button--tertiary expando-button float-right"
              (click)="expandOrCollapse( hasOpenAccordion, ulAccordionList)">
              {{hasOpenAccordion ? ('General.CollapseAll' | translate) : ('General.ExpandAll' | translate)}}
            </button>
          </ng-container>
        }
        @for (pc of ulpageContents; track pc; let i = $index) {
          @if (i==0) {
            <div id="learnerlogin" [ngClass]="{'border-bottom': i == (ulpageContents.length)-1}">
              <app-accordion #ul [accordionTitle]="currentLang == 'en' ? pc.Title: pc.TitleFr" [accordionIndex]="-1" [accordionBody]="currentLang == 'en'? pc.Content: pc.ContentFr">
              </app-accordion>
            </div>
          }
          @if (i==1) {
            <div id="tplogin" [ngClass]="{'border-bottom': i == (ulpageContents.length)-1}">
              <app-accordion #ul [accordionTitle]="currentLang == 'en' ? pc.Title: pc.TitleFr" [accordionIndex]="-1" [accordionBody]="currentLang == 'en'? pc.Content: pc.ContentFr">
              </app-accordion>
            </div>
          }
        }
      }
      @if (rflpageContents.length>0) {
        <h2>{{'FAQHome.ResourcesforLearners' | translate}}</h2>
        @for (hasOpenAccordion of [hasOpenAccordion(rflAccordionList??rflpageContents)]; track hasOpenAccordion) {
          <ng-container
            style="border-bottom: 1px;">
            <button class="ontario-button ontario-button--tertiary expando-button float-right"
              (click)="expandOrCollapse( hasOpenAccordion, rflAccordionList)">
              {{hasOpenAccordion ? ('General.CollapseAll' | translate) : ('General.ExpandAll' | translate)}}
            </button>
          </ng-container>
        }
        @for (pc of rflpageContents; track pc; let i = $index) {
          <div class="" [ngClass]="{'border-bottom': i == (rflpageContents.length)-1}">
            <app-accordion #rfl [accordionTitle]="currentLang == 'en'? pc.Title: pc.TitleFr" [accordionIndex]="-1" [accordionBody]="currentLang == 'en'? pc.Content: pc.ContentFr">
            </app-accordion>
          </div>
        }
      }
      @if (rftppageContents.length>0) {
        <h2>{{'FAQHome.ResourcesforTrainingProviders' | translate}}</h2>
        @for (hasOpenAccordion of [hasOpenAccordion(rftpAccordionList??rftppageContents)]; track hasOpenAccordion) {
          <ng-container
            style="border-bottom: 1px;">
            <button class="ontario-button ontario-button--tertiary expando-button float-right"
              (click)="expandOrCollapse( hasOpenAccordion, rftpAccordionList)">
              {{hasOpenAccordion ? ('General.CollapseAll' | translate) : ('General.ExpandAll' | translate)}}
            </button>
          </ng-container>
        }
        @for (pc of rftppageContents; track pc; let i = $index) {
          <div id="tpguide" [ngClass]="{'border-bottom': i == (rftppageContents.length)-1}">
            <app-accordion #rftp [accordionTitle]="currentLang == 'en'? pc.Title: pc.TitleFr" [accordionIndex]="-1" [accordionBody]="currentLang == 'en'? pc.Content: pc.ContentFr">
            </app-accordion>
          </div>
        }
      }
      @if (cupageContents.length>0) {
        <h2>{{'FAQHome.Contactus' | translate}}</h2>
        @for (hasOpenAccordion of [hasOpenAccordion(cuAccordionList??cupageContents)]; track hasOpenAccordion) {
          <ng-container
            style="border-bottom: 1px;">
            <button class="ontario-button ontario-button--tertiary expando-button float-right"
              (click)="expandOrCollapse( hasOpenAccordion, cuAccordionList)">
              {{hasOpenAccordion ? ('General.CollapseAll' | translate) : ('General.ExpandAll' | translate)}}
            </button>
          </ng-container>
        }
        @for (pc of cupageContents; track pc; let i = $index) {
          <div class="" [ngClass]="{'border-bottom': i == (cupageContents.length)-1}">
            <app-accordion #cu [accordionTitle]="currentLang == 'en'? pc.Title: pc.TitleFr" [accordionIndex]="-1" [accordionBody]="currentLang == 'en'? pc.Content: pc.ContentFr">
            </app-accordion>
          </div>
        }
      }
      @if (mispageContents.length>0) {
        <h2>{{'FAQHome.Miscellaneous' | translate}}</h2>
        @for (hasOpenAccordion of [hasOpenAccordion(misAccordionList??mispageContents)]; track hasOpenAccordion) {
          <ng-container
            style="border-bottom: 1px;">
            <button class="ontario-button ontario-button--tertiary expando-button float-right"
              (click)="expandOrCollapse( hasOpenAccordion, misAccordionList)">
              {{hasOpenAccordion ? ('General.CollapseAll' | translate) : ('General.ExpandAll' | translate)}}
            </button>
          </ng-container>
        }
        @for (pc of mispageContents; track pc; let i = $index) {
          <div class="" [ngClass]="{'border-bottom': i == (mispageContents.length)-1}">
            <app-accordion #mis [accordionTitle]="currentLang == 'en'? pc.Title: pc.TitleFr" [accordionIndex]="-1" [accordionBody]="currentLang == 'en'? pc.Content: pc.ContentFr">
            </app-accordion>
          </div>
        }
      }
    </div>
  </div>
}
